import { KineticForm } from 'components/forms';
import { useFiltersContext } from './contexts/filtersContext';
import { useInitializeFilterValues } from './hooks/useInitialFilterValues';

export const Filters = () => {
  const { form } = useFiltersContext();

  useInitializeFilterValues();

  return <KineticForm {...form.props} />;
};
